import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';

import { catchError, map, switchMap, take } from 'rxjs/operators';
import { IEffect } from '@ordersnproducts/modules/shared/modules/dynamic-effects/effect.interface';
import {
  JobsiteLoadFailAction,
  LS_SALES_AREA_LOAD,
  SalesAreaLoadAction,
  SalesAreaLoadCompleteAction,
} from '../actions/jobsite-actions/jobsite.actions';
import { JobsiteLoaderService } from '@ordersnproducts/modules/order-builder/modules/location-specification/services/loaders/jobsite.loader.service';
import { ProductLoaderService } from '@ordersnproducts/modules/order-builder/modules/location-specification/services/loaders/product.loader.service';
import * as fromAdditionalServicesAction from '@ordersnproducts/modules/new-modify-order/modules/new-modify-product-specification/actions/additional-services.action';
import { IMyProductRequest } from '@ordersnproducts/modules/order-builder/modules/location-specification/models/order-management/product.model';
import { IJobsiteSalesAreaResponse } from '@ordersnproducts/modules/order-builder/modules/location-specification/models/order-management/jobsite-sales-area.model';
import { ModifyOrderState } from '@ordersnproducts/modules/new-modify-order/reducers';

@Injectable()
export class JobsiteLoadSalesAreasEffects implements IEffect {
  jobsiteSalesAreaLoadUL$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LS_SALES_AREA_LOAD),
      switchMap((action: SalesAreaLoadAction) => {
        return this.jobsiteLoaderService
          .getJobsiteSalesAreas(action.payload.productlineId, action.payload.shipmentlocationId)
          .pipe(
            map((salesAreaResponse: IJobsiteSalesAreaResponse) => {
              if (salesAreaResponse.count > 0) {
                const request: IMyProductRequest = {
                  salesDocumentTypeCode: 'Z',
                  productLineId: action.payload.productlineId,
                  shippingConditionId: action.payload.shippingConditionId,
                  salesAreaId: salesAreaResponse.jobsiteSalesAreas[0].salesArea.salesAreaId,
                  jobsiteId: action.payload.shipmentlocationId.toString() + '.2',
                };

                this.productLoaderService
                  .getMyProductsV3(request)
                  .pipe(
                    take(1),
                    catchError((error) => of(new JobsiteLoadFailAction(error))),
                  )
                  .subscribe((response: any) => {
                    if (response.products.length > 0) {
                      this.store.dispatch(
                        new fromAdditionalServicesAction.AddAdditionalServices({
                          additionalServices: response.products,
                        }),
                      );
                    }
                  });
              }
              return new SalesAreaLoadCompleteAction({
                salesAreas: salesAreaResponse,
              });
              // return new JobsiteLoadCompleteAction(shipmentLocationResponse);
            }),
            catchError((error) => of(new JobsiteLoadFailAction(error))),
          );
      }),
    ),
  );

  constructor(
    private store: Store<ModifyOrderState>,
    private actions$: Actions,
    private jobsiteLoaderService: JobsiteLoaderService,
    private productLoaderService: ProductLoaderService,
  ) {}
}
